// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@use './components/Drawer/Drawer.scss';@use './components/Drawer/DrawerSection.scss';@use './components/Drawer/VisualViewer/VisualViewer.scss';.explorer{position:fixed;top:50px;left:0;padding:20px;z-index:500}.explorer-backdrop{position:fixed;display:inline-block;height:100vh;width:100vw;pointer-events:none;z-index:0;background:rgba(64,92,115,0.3);top:0;left:0}\n", ""]);
// Exports
module.exports = exports;
